// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Navbar.module.css */

.navbar {
  background: rgba(var(--background-rgb), 0.95);
  border-bottom: 1px solid var(--border);
  position: sticky;
  top: 0;
  z-index: 50;
  backdrop-filter: blur(4px);
}

.navbarContainer {
  max-width: 80rem;
  margin: 0 auto;
  padding: 0 1rem;
}

@media (min-width: 640px) {
  .navbarContainer {
    padding: 0 1.5rem;
  }
}

@media (min-width: 1024px) {
  .navbarContainer {
    padding: 0 2rem;
  }
}

.navbar .flex {
  display: flex;
}

.navbar .justify-between {
  justify-content: space-between;
}

.navbar .items-center {
  align-items: center;
}

.navbar .h-16 {
  height: 4rem;
}

.navbar .space-x-3 > * + * {
  margin-left: 0.75rem;
}

.navbar .w-10 {
  width: 2.5rem;
}

.navbar .h-10 {
  height: 2.5rem;
}

.navbar .bg-gradient-to-br {
  background: linear-gradient(to bottom right, var(--primary), var(--secondary));
}

.navbar .rounded-xl {
  border-radius: 0.75rem;
}

.navbar .text-white {
  color: white;
}

.navbar .text-xl {
  font-size: 1.25rem;
}

.navbar .font-bold {
  font-weight: 700;
}

.navbar .text-foreground {
  color: var(--foreground);
}

.navbar .hidden {
  display: none;
}

.navbar .md\\:flex {
  display: flex;
}

.navbar .space-x-8 > * + * {
  margin-left: 2rem;
}

.navbar .navLink {
  color: var(--foreground);
  text-decoration: none;
  transition: color 0.2s;
  font-weight: 500;
  position: relative;
}

.navbar .navLink:hover {
  color: var(--primary);
}

.navbar .navLink::after {
  content: '';
  position: absolute;
  width: 0;
  height: 2px;
  bottom: 0;
  left: 0;
  background-color: var(--primary);
  transition: width 0.3s;
}

.navbar .navLink:hover::after {
  width: 100%;
}

.navbar .space-x-4 > * + * {
  margin-left: 1rem;
}

.navbar .btn-hero {
  background: linear-gradient(to right, var(--primary), var(--secondary));
  color: white;
  border: none;
  padding: 1rem 2rem;
  border-radius: 0.75rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

.navbar .btn-hero:hover {
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  transform: scale(1.05);
}

.navbar .md\\:hidden {
  display: none;
}

.navbar .navToggle {
  background: transparent;
  border: none;
  color: var(--foreground);
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 0.375rem;
  transition: background-color 0.2s;
}

.navbar .navToggle:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.navbar .logo {
  text-decoration: none;
}

@media (min-width: 768px) {
  .navbar .hidden {
    display: flex;
  }
  .navbar .md\\:hidden {
    display: none;
  }
}

/* Media queries */
@media (max-width: 700px) {
  .navbarContainer {
    flex-direction: column !important;
    height: auto !important;
    padding: 8px 4px !important;
  }
  .navLinks {
    flex-direction: column !important;
    gap: 8px !important;
    width: 100%;
    align-items: flex-start !important;
  }
  .navLinks li {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Navbar.css"],"names":[],"mappings":"AAAA,sBAAsB;;AAEtB;EACE,6CAA6C;EAC7C,sCAAsC;EACtC,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,8EAA8E;AAChF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,SAAS;EACT,OAAO;EACP,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,uEAAuE;EACvE,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mFAAmF;AACrF;;AAEA;EACE,qFAAqF;EACrF,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,wBAAwB;EACxB,eAAe;EACf,eAAe;EACf,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;AACF;;AAEA,kBAAkB;AAClB;EACE;IACE,iCAAiC;IACjC,uBAAuB;IACvB,2BAA2B;EAC7B;EACA;IACE,iCAAiC;IACjC,mBAAmB;IACnB,WAAW;IACX,kCAAkC;EACpC;EACA;IACE,WAAW;EACb;AACF","sourcesContent":["/* Navbar.module.css */\n\n.navbar {\n  background: rgba(var(--background-rgb), 0.95);\n  border-bottom: 1px solid var(--border);\n  position: sticky;\n  top: 0;\n  z-index: 50;\n  backdrop-filter: blur(4px);\n}\n\n.navbarContainer {\n  max-width: 80rem;\n  margin: 0 auto;\n  padding: 0 1rem;\n}\n\n@media (min-width: 640px) {\n  .navbarContainer {\n    padding: 0 1.5rem;\n  }\n}\n\n@media (min-width: 1024px) {\n  .navbarContainer {\n    padding: 0 2rem;\n  }\n}\n\n.navbar .flex {\n  display: flex;\n}\n\n.navbar .justify-between {\n  justify-content: space-between;\n}\n\n.navbar .items-center {\n  align-items: center;\n}\n\n.navbar .h-16 {\n  height: 4rem;\n}\n\n.navbar .space-x-3 > * + * {\n  margin-left: 0.75rem;\n}\n\n.navbar .w-10 {\n  width: 2.5rem;\n}\n\n.navbar .h-10 {\n  height: 2.5rem;\n}\n\n.navbar .bg-gradient-to-br {\n  background: linear-gradient(to bottom right, var(--primary), var(--secondary));\n}\n\n.navbar .rounded-xl {\n  border-radius: 0.75rem;\n}\n\n.navbar .text-white {\n  color: white;\n}\n\n.navbar .text-xl {\n  font-size: 1.25rem;\n}\n\n.navbar .font-bold {\n  font-weight: 700;\n}\n\n.navbar .text-foreground {\n  color: var(--foreground);\n}\n\n.navbar .hidden {\n  display: none;\n}\n\n.navbar .md\\:flex {\n  display: flex;\n}\n\n.navbar .space-x-8 > * + * {\n  margin-left: 2rem;\n}\n\n.navbar .navLink {\n  color: var(--foreground);\n  text-decoration: none;\n  transition: color 0.2s;\n  font-weight: 500;\n  position: relative;\n}\n\n.navbar .navLink:hover {\n  color: var(--primary);\n}\n\n.navbar .navLink::after {\n  content: '';\n  position: absolute;\n  width: 0;\n  height: 2px;\n  bottom: 0;\n  left: 0;\n  background-color: var(--primary);\n  transition: width 0.3s;\n}\n\n.navbar .navLink:hover::after {\n  width: 100%;\n}\n\n.navbar .space-x-4 > * + * {\n  margin-left: 1rem;\n}\n\n.navbar .btn-hero {\n  background: linear-gradient(to right, var(--primary), var(--secondary));\n  color: white;\n  border: none;\n  padding: 1rem 2rem;\n  border-radius: 0.75rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s;\n  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n}\n\n.navbar .btn-hero:hover {\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  transform: scale(1.05);\n}\n\n.navbar .md\\:hidden {\n  display: none;\n}\n\n.navbar .navToggle {\n  background: transparent;\n  border: none;\n  color: var(--foreground);\n  cursor: pointer;\n  padding: 0.5rem;\n  border-radius: 0.375rem;\n  transition: background-color 0.2s;\n}\n\n.navbar .navToggle:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n\n.navbar .logo {\n  text-decoration: none;\n}\n\n@media (min-width: 768px) {\n  .navbar .hidden {\n    display: flex;\n  }\n  .navbar .md\\:hidden {\n    display: none;\n  }\n}\n\n/* Media queries */\n@media (max-width: 700px) {\n  .navbarContainer {\n    flex-direction: column !important;\n    height: auto !important;\n    padding: 8px 4px !important;\n  }\n  .navLinks {\n    flex-direction: column !important;\n    gap: 8px !important;\n    width: 100%;\n    align-items: flex-start !important;\n  }\n  .navLinks li {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
